import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const KeypadInterfacing = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Keypad Interfacing with 8051 Microcontroller"
      videos={[
        "https://www.youtube.com/embed/dqo-PA-_a0Q", // Basic keypad interfacing
        "https://www.youtube.com/embed/yp-D8S-5ECk", // 8051 ALP for keyboard interfacing
      ]}
      takeaways={[
        {
          text: "Mostly direct questions will be asked where we need to write the Assembly Language Program (ALP).",
        },
        {
          text: "Sometimes row and column values will be given, and we need to find which key is pressed (for 3 or 5 marks).",
        },
      ]}
      questions={[
        "Develop an assembly language program to interface a 4x4 matrix keyboard with 8051 microcontroller.",
        "Develop an 8051 assembly program such that P1.0 to P1.3 are connected to the rows and P2.0 to P2.3 are connected to the columns of a 4x4 keypad, detect, identify the pressed key and display the ASCIl value of the pressed key at Port PO.",
      ]}
      exampleVideos={[]} // No extra example videos
    />
  );
}

export default KeypadInterfacing;
